import React, {FC} from 'react';
import {IWifiAnalyzerResults} from '../../services/AngularServices/WifiAnalyzerService';
import {getWifiAnalyzerScanRecordId, sortWifiAnalyzerResultsByDateDesc} from '../right-bar/wifi-scan-history.utils';
import {VisualScanHistoryButton} from './VisualScanHistoryButton';
import {observer} from 'mobx-react';
import './styles.scss';

interface IWifiScanHistoryButtonProps {
    onClickWifiScanHistoryButton: (wifiScanData: string) => void;
    wifiScanHistoryData?: IWifiAnalyzerResults[];
    visualScanTranslation: string;
}

export const VisualScanHistory: FC<IWifiScanHistoryButtonProps> = observer(
    ({wifiScanHistoryData, onClickWifiScanHistoryButton, visualScanTranslation}) => {
        const data = wifiScanHistoryData ? sortWifiAnalyzerResultsByDateDesc(wifiScanHistoryData) : [];

        // Helper function to extract ssid_heatmap image URL
        const getSsidHeatmapImage = (wifiScan: IWifiAnalyzerResults): string | undefined => {
            const imageUrls = wifiScan.connectivityHeatmapData?.imageUrls;
            if (!imageUrls || imageUrls.length === 0) {
                return undefined;
            }

            const ssidHeatmaps = imageUrls.filter((img) => img.type === 'ssid_heatmap');
            return ssidHeatmaps.length > 0 ? ssidHeatmaps[0].imageUrl : undefined;
        };

        return (
            <div className='scan-wifi-history-container'>
                <ul className='scan-wifi-history-list'>
                    {Array.isArray(data) &&
                        data.map((wifiScan: IWifiAnalyzerResults, index) => {
                            const ssidImage = getSsidHeatmapImage(wifiScan);
                            return (
                                <li key={getWifiAnalyzerScanRecordId(wifiScan) || `visual-scan-${index}`}>
                                    <VisualScanHistoryButton
                                        wifiScanData={wifiScan}
                                        onClickWifiScanHistoryButton={onClickWifiScanHistoryButton}
                                        ssidImage={ssidImage}
                                    />
                                </li>
                            );
                        })}
                </ul>
            </div>
        );
    }
);
